import GameAssignmentsFilter from "./GameAssignmentsFilter";

export default GameAssignmentsFilter;